import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export default function useVehicleInspectionReservationUtil() {
  const {t} = useInferableTranslation();

  const inspectionLabels: Record<string, string> = {
    '21': t('T40183'),
    '2b': t('T40184'),
    Ag: t('T40185'),
    Ah: t('T40186'),
    Bp: t('T40187'),
    Bq: t('T40188'),
  };

  return {inspectionLabels};
}
